import * as React from "react"

const Retail = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 278.95 248.37"
    {...props}
  >
    <defs>
      <clipPath id="path">
        <path fill="none" d="M47.02 107.6H147.3v79H47.02z" />
      </clipPath>
    </defs>
    <title>{"RETAIL-SHiPX-2"}</title>
    <path
      fill="#00b08e"
      d="M261.23 60.05v163.14h-25.39v-117.6h-67.12v117.6H17.47V60.06l243.76-.01z"
    />
    <path
      fill="#007f6e"
      d="M6.42 80.41 3.21 77.2V54.13l3.21-3.21h47.06l3.22 3.21V77.2l-3.22 3.21H6.42z"
    />
    <path
      d="M53.48 54.12v23.06H6.42V54.12h47.06m0-6.42H6.42L0 54.12v23.06l6.42 6.42h47.06l6.43-6.42V54.12Z"
      fill="#fff"
    />
    <path
      fill="#007f6e"
      d="m115.59 80.41-3.21-3.21V54.13l3.21-3.22h47.3l3.21 3.22V77.2l-3.21 3.21h-47.3z"
    />
    <path
      d="M162.89 54.12v23.06h-47.3V54.12h47.3m0-6.42h-47.3l-6.42 6.42v23.06l6.42 6.42h47.3l6.42-6.42V54.12Z"
      fill="#fff"
    />
    <path
      fill="#007f6e"
      d="m225.23 80.41-3.21-3.21V54.13l3.21-3.22h47.29l3.22 3.22V77.2l-3.22 3.21h-47.29z"
    />
    <path
      d="M272.52 54.12v23.06h-47.29V54.12h47.29m0-6.42h-47.29l-6.43 6.42v23.06l6.43 6.42h47.29l6.48-6.42V54.12Z"
      fill="#fff"
    />
    <path
      fill="#00b08e"
      d="m170.65 80.41-3.21-3.21V54.13l3.21-3.22h47.29l3.21 3.22V77.2l-3.21 3.21h-47.29z"
    />
    <path
      d="M217.94 54.12v23.06h-47.29V54.12h47.29m0-6.42h-47.29l-6.43 6.42v23.06l6.43 6.42h47.29l6.42-6.42V54.12Z"
      fill="#fff"
    />
    <path
      fill="#00b08e"
      d="m61.48 80.41-3.21-3.21V54.13l3.21-3.22h47.3l3.21 3.22V77.2l-3.21 3.21h-47.3z"
    />
    <path
      d="M108.78 54.12v23.06h-47.3V54.12h47.3m0-6.42h-47.3l-6.42 6.42v23.06l6.42 6.42h47.3l6.42-6.42V54.12Z"
      fill="#fff"
    />
    <path fill="#00b08e" d="M170.53 54.13 161.76 0h32.27l23.5 54.13h-47z" />
    <path fill="#007f6e" d="M115.85 54.13 123.23 0h32.28l7.31 54.13h-46.97z" />
    <path fill="#00b08e" d="M61.14 54.13 84.71 0h32.26l-8.83 54.13h-47z" />
    <path fill="#007f6e" d="M6.42 54.13 46.22 0h32.2L53.48 54.13H6.42z" />
    <path fill="#b1da00" d="M175.37 112.23h54.19v110.95h-54.19z" />
    <path fill="#007f6e" d="M225.19 54.13 200.32 0h32.21l39.73 54.13h-47.07z" />
    <path d="M47 107.6h100.3v79H47Z" fill="#fff" />
    <circle cx={188.14} cy={165.52} r={5.77} fill="#fff" />
    <path fill="#fff" d="M6.42 53.06h267.3v2.14H6.42z" />
    <path fill="#007f6e" d="M5.58 231.23h266.76v17.14H5.58z" />
    <g clipPath="url(#path)">
      <path
        fill="#00b08e"
        d="m96.57 211.47-34.52-19.93v-39.86l34.52 19.93v39.86z"
      />
      <path
        fill="#007f6e"
        d="M131.09 151.68v39.86l-34.52 19.93v-39.86l34.52-19.93z"
      />
      <path
        fill="#b1da00"
        d="m131.09 151.73-34.52-19.89-34.52 19.89 34.52 19.88 34.52-19.88z"
      />
      <path
        fill="#00b08e"
        d="m96.44 160.86-19.98-11.54v-23.07l19.98 11.54v23.07z"
      />
      <path
        fill="#007f6e"
        d="M116.42 126.25v23.07l-19.98 11.54v-23.07l19.98-11.54z"
      />
      <path
        fill="#b1da00"
        d="m116.42 126.28-19.98-11.51-19.98 11.51 19.98 11.51 19.98-11.51z"
      />
    </g>
    <path
      d="M149.44 188.74H44.88v-83.28h104.56Zm-100.28-4.28h96v-74.72h-96Z"
      fill="#fff"
    />
  </svg>
)

export default Retail
